import { render } from "./ProfessorList.vue?vue&type=template&id=d4244ef8"
import script from "./ProfessorList.vue?vue&type=script&lang=js"
export * from "./ProfessorList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__